import { ITransform, ITransformRow, TRANSFROM_MAX_TOKENS } from '../../../../models/ITransform';
import { guid } from '../../../../../../alan_btn/src/helpers/mini/guid';
import * as _ from 'lodash';

export function getTransformText(transform: ITransform, clean: boolean) {
    let hasFilledRow = false;
    const defaultConfig = getEmptyTransform().config;

    for (let i = 0; i < transform?.rows?.length; i++) {
        const r = transform.rows[i];
        if (r.input !== undefined || r.query !== undefined || r.prompt !== undefined || r.result !== undefined) {
            hasFilledRow = true;
            break;
        }
    }

    const config = {
        "iq": transform?.config?.iq === defaultConfig.iq ? null : transform?.config?.iq,
        "temperature": transform?.config?.temperature ?? defaultConfig.temperature,
        "maxTokens": transform?.config?.maxTokens ?? defaultConfig.maxTokens,
    };

    if (!hasFilledRow) {
        return JSON.stringify({
            "header": {
                "input": { "format": transform?.header?.input?.format || "text" },
                "query": { "format": transform?.header?.query?.format || "text" },
                "prompt": { "format": "text", "value": transform?.header?.prompt?.value || "" },
                "result": { "format": transform?.header?.result?.format || "text" },
            },
            "rows": [],
            "config": config
        }, null, 4);
    }

    return JSON.stringify({
        "header": {
            "input": { "format": transform?.header?.input?.format || "text" },
            "query": { "format": transform?.header?.query?.format || "text" },
            "prompt": { "format": "text", "value": transform?.header?.prompt?.value || "" },
            "result": { "format": transform?.header?.result?.format || "text" },
        },
        "rows": transform?.rows?.map(r => getTransformRowWithoutId(r, clean)),
        "config": config
    }, null, 4);

}

export function getTransformRowWithoutId(row, clean) {
    if (clean) {
        return {
            input: row.input || '',
            query: row.query || '',
            prompt: row.prompt || '',
            result: row.result || '',
        };
    }
    return {
        input: row.input || '',
        query: row.query || '',
        prompt: row.prompt || '',
        result: row.result || '',
        deleting: row.deleting,
    };

}

export function getEmptyTransformRow(rowIndex): ITransformRow {
    return {
        id: guid(),
        input: '',
        query: '',
        prompt: '',
        result: '',
        editing: false,
        deleting: false,
        visible: true,
        isNew: true,
        rowIndex
    };
}

export function getEmptyTransform(): ITransform {
    return {
        header: {
            input: { format: 'text' },
            query: { format: 'text' },
            prompt: { format: 'text', value: '' },
            result: { format: 'text' },
        },
        rows: [
            getTransformRowWithoutId(getEmptyTransformRow(0), true) as ITransformRow,
        ],
        config: {
            iq: null,
            temperature: null,
            maxTokens: null
        }
    };
}

export function getEmptyTransformText() {
    return JSON.stringify(getEmptyTransform());
}

export function removeEmptyRowsFromTransform(transform: ITransform): ITransform {
    if (!transform || !transform.rows || !Array.isArray(transform.rows)) {
        console.error("Invalid JSON format or missing 'rows' array.");
        return transform;
    }
    transform.rows = transform.rows
        .map((row: ITransformRow) => {
            const filteredRow: ITransformRow = {} as ITransformRow;
            for (const key in row) {
                if (row[key] !== undefined && row[key] !== null && row[key] !== "") {
                    filteredRow[key] = row[key];
                }
            }
            return filteredRow;
        })
        .filter((filteredRow: ITransformRow) => Object.keys(filteredRow).length > 0);
    return transform;
}

export function isTransformValid(transform: ITransform) {
    const maxTokens = transform.config?.maxTokens;

    return isMaxTokensValid(maxTokens);
}

export function isMaxTokensValid(maxTokens: number) {
    if (maxTokens === null || maxTokens === undefined) {
        return true;
    }
    return +maxTokens >= 256 && +maxTokens <= TRANSFROM_MAX_TOKENS;
}